'use client'
import { createContext, useContext, useMemo, useState } from 'react'
import { WallOfFameStoryModalCarousel } from 'components/Carousels/WallOfFameStoryModalCarousel'

const GraduateContext = createContext()

const GraduateProvider = ({ children, initialState = null, initialHighlights = {} }) => {
  const [graduate, setGraduate] = useState(initialState)
  const [isModalOpen, setIsModalOpen] = useState(initialState)

  const { largestDebtAmount, fastestCompletion } = initialHighlights

  const contextValue = useMemo(
    () => ({
      graduate,
      setGraduate,
      largestDebtAmount,
      fastestCompletion,
    }),
    [graduate, largestDebtAmount, fastestCompletion]
  )

  return (
    <GraduateContext.Provider value={contextValue}>
      {graduate && (
        <WallOfFameStoryModalCarousel
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          isGraduatedView
          story={graduate}
        />
      )}
      {children}
    </GraduateContext.Provider>
  )
}

const useGraduate = () => {
  const context = useContext(GraduateContext)

  if (!context) {
    // Return safe default when provider not present
    return {
      graduate: null,
      setGraduate: () => {},
    }
  }

  return context
}

export { GraduateProvider, useGraduate }
